import {loadStripe, type Stripe} from '@stripe/stripe-js';
import * as React from 'react';

type StripeData = {
  promise: Promise<Stripe | null>;
  key: string;
  stripeAccount: string | undefined;
};

export function useStripe(
  key: string,
  stripeAccount?: string,
): Promise<Stripe | null> {
  const stripe = React.useRef<StripeData>();
  if (!stripe.current) {
    stripe.current = {
      promise: loadStripe(key, {stripeAccount}),
      key,
      stripeAccount,
    };
  }
  React.useEffect(() => {
    if (
      key !== stripe.current!.key ||
      stripeAccount !== stripe.current!.stripeAccount
    ) {
      stripe.current = {
        promise: loadStripe(key, {stripeAccount}),
        key,
        stripeAccount,
      };
    }
  }, [key, stripeAccount]);
  return stripe.current!.promise;
}

export const stripeKey = document
  .querySelector('meta[name=stripe_publishable_key]')!
  .getAttribute('content')!;
